(function () {
  if (window.__cwcEmptyPopupCouponGuard) return;
  window.__cwcEmptyPopupCouponGuard = true;
  function protect(api) {
    if (!api || typeof api.doActivateDiscount !== 'function' || api.doActivateDiscount.__cwcGuarded) return api;
    var activate = api.doActivateDiscount;
    var guarded = function (code) {
      // The popup app opens a hidden /checkout?discount= even with no coupon.
      // That can clear active codes and restore an older checkout cart snapshot.
      if (code == null || String(code).trim() === '') return;
      return activate.apply(this, arguments);
    };
    guarded.__cwcGuarded = true;
    api.doActivateDiscount = guarded;
    return api;
  }
  var current = protect(window.SCAPPApi);
  var descriptor = Object.getOwnPropertyDescriptor(window, 'SCAPPApi');
  if (!descriptor || descriptor.configurable) {
    Object.defineProperty(window, 'SCAPPApi', {
      configurable: true,
      enumerable: true,
      get: function () { return current; },
      set: function (api) { current = protect(api); }
    });
  }
})();
